import React from 'react'
import { TfiShiftRightAlt } from "react-icons/tfi";

const Logo = () => {
  return (
    <div className='flex items-center'>
      <TfiShiftRightAlt className='text-base font-medium font-poppins'/>Decorhub
    </div>
  )
}

export default Logo
